import { Component } from '@angular/core';
import { PrimeNgArrayD4Component } from '../shared/prime-ng-array-d4/prime-ng-array-d4.component';
import { MaterialModule } from '../material-module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { GetJsonObjectService } from '../shared/services/get-json-object.service';
import { PutJsonObjectService } from '../shared/services/put-json-object.service';
import { first, forkJoin } from 'rxjs';
import { columnDefinition, twoLinesDisplay } from '../shared/prime-ng-array-d4/prime-ng-array-d4.service';
import { environment } from '../../environments/environment';
import { deviceService } from '../shared/servicesHardware/deviceService';

@Component({
  selector: 'app-commandes',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule, PrimeNgArrayD4Component, MaterialModule],
  templateUrl: './commandes.html',
  styleUrl: './commandes.scss'
})
export class Commandes {

  public columnsDefinition: columnDefinition[] = [];
  public orders: any[] = [];
  public loading: boolean = true;
  private dowloadImgB64: string = "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjMDAwMDAwIj48cGF0aCBkPSJNNDgwLTMyMCAyODAtNTIwbDU2LTU4IDEwNCAxMDR2LTMyNmg4MHYzMjZsMTA0LTEwNCA1NiA1OC0yMDAgMjAwWk0yNDAtMTYwcS0zMyAwLTU2LjUtMjMuNVQxNjAtMjQwdi0xMjBoODB2MTIwaDQ4MHYtMTIwaDgwdjEyMHEwIDMzLTIzLjUgNTYuNVQ3MjAtMTYwSDI0MFoiLz48L3N2Zz4="

  constructor(
    private getJsonObjectService: GetJsonObjectService,
    private putJsonService: PutJsonObjectService,
    private deviceService: deviceService
  ) {
    this.getDatas();
    this.columnsDefinition = [
      { displayName: "Pointage", name: "customerValidation", readOnly: false, ngStyle: { 'flex.px': '0 0 130' }, type: 'booleanCheckBoxSwitch', enum: null, drop: null, localFilter: true },
      { displayName: "Commande", name: "orderNumber", readOnly: true, ngStyle: { 'flex.px': '0 0 200' }, type: 'string', enum: null, drop: null, localFilter: true },
      { displayName: "Libellé", name: "orderDescription", readOnly: true, ngStyle: { 'flex.px': '0 0 500' }, type: 'string', enum: null, drop: null, localFilter: true },
      { displayName: "Société", name: "subscriberName", readOnly: true, ngStyle: { 'flex.px': '0 0 130' }, type: 'string', enum: null, drop: null, localFilter: true },
      { displayName: "Date", name: "orderDate", readOnly: true, ngStyle: { 'flex.px': '0 0 130' }, type: 'date', enum: null, drop: null, localFilter: true },
      {
        displayName: "Temps prévu", name: "totalWork", readOnly: true, ngStyle: { 'flex.px': '0 0 140' }, type: 'duration', enum: null, drop: null, localFilter: true,
        printLine: {
          methodImplementation: (object) => {
            if (object?.totalWork != null) {
              let returnValue: twoLinesDisplay = {
                topLine: '<span style="text-align: right">' + (object.totalWork / 3600).toFixed(2) + " h" + '</span>',
                bottomLine: ""
              }
              return returnValue
            }
            else {
              let returnValue: twoLinesDisplay = {
                topLine: '<span style="text-align: right"> </span>',
                bottomLine: ""
              }
              return returnValue
            }
          }
        },
      },
      {
        displayName: "Temps", name: "totalWork", readOnly: true, ngStyle: { 'flex.px': '0 0 140' }, type: 'duration', enum: null, drop: null, localFilter: true,
        printLine: {
          methodImplementation: (object) => {
            if (object?.remainingWork != null) {
              let remainingWorkStr = "";
              if (object.remainingWork >= 0)
                remainingWorkStr = '<span style="text-align: right">' + (object.remainingWork / 3600).toFixed(2) + " h restant </span>";
              else
              {
                remainingWorkStr = '<span style="text-align: right ; color : red">' +  Math.abs((object.remainingWork / 3600)).toFixed(2) + " h en dépassement</span>";
              }

              let returnValue: twoLinesDisplay = {
                topLine: remainingWorkStr,
                bottomLine: ""
              }
              return returnValue
            }
            else {
              let returnValue: twoLinesDisplay = {
                topLine: '<span style="text-align: right"> </span>',
                bottomLine: ""
              }
              return returnValue
            }
          }
        },
      },
      {
        displayName: "Télécharger", name: "download", readOnly: true, ngStyle: { 'flex.px': '1 0 80', 'cursor': 'pointer' }, type: 'link', enum: null, drop: null, localFilter: false,
        printLine: {
          methodImplementation: (object) => {
            if (object?.download != null) {
              let returnValue: twoLinesDisplay = {
                topLine: ' <img style="cursor: pointer;" src="data:image/svg+xml;base64,' + this.dowloadImgB64 + '" />',
                bottomLine: ""
              }
              return returnValue
            }
            else {
              let returnValue: twoLinesDisplay = {
                topLine: '<span style="text-align: right"> </span>',
                bottomLine: ""
              }
              return returnValue
            }
          }
        },
      },
    ];
  }

  public rowAction(event: any) {
    console.log(event);
    let oldValue = event?.oldValue.customerValidation
    let newValue = event?.newValue.customerValidation
    if (oldValue != undefined && newValue != undefined && oldValue != newValue) {
      this.putJsonService.sendJson("cm/orders/" + event.newValue.orderUniqueId, event.newValue)
        .pipe(
          first()).subscribe(
            result => {
              console.log(result);
            });
    }
  }

  public refresh() { this.loading = true; this.orders = []; this.getDatas(); }

  private getDatas() {
    let getterObservable: any[] = [];
    getterObservable.push(this.getJsonObjectService.getJson("cm/orders"));
    getterObservable.push(this.getJsonObjectService.getJson("support/companies/my"));

    forkJoin(getterObservable).subscribe(
      (getterObservableResult: any) => {
        this.initialData(getterObservableResult[0], getterObservableResult[1]);
      }
    );
  }

  private initialData(orders: any[], societyList: any[]) {
    if (Array.isArray(orders)) {
      orders.forEach(order => {
        if (societyList.find((society: any) => society.companyUniqueId == order.companyUniqueId) != null)
          order.subscriberName = societyList.find((society: any) => society.companyUniqueId == order.companyUniqueId).companyName;
        if (order?.documentFileSize > 0) {
          order.download = environment.url + "cm/orders/" + order.orderUniqueId + "/document?access_token=" + this.deviceService.decryptDataLocalStorage('userSession').currentUser;
        }
        order["id"] = order.orderUniqueId;
        this.orders.push(order);
      })
    }
    this.loading = false;
  }
}
